@if (statusMapping[status()]; as mapping) {
  <button
    [sbMenuTriggerFor]="statusMenu.panel"
    [sbMenuTriggerPlacement]="placement()"
    [sbMenuTriggerDisabled]="saving()"
    sb-icon-button
    [color]="mapping.button"
  >
    @if (!saving()) {
      <sb-icon [name]="mapping.icon" />
      <span class="sr-only">{{ mapping.label | translate }}</span>
    } @else {
      <sb-spinner [size]="'sm'" [strokeColor]="'current'"></sb-spinner>
    }
    <sb-icon iconPositionEnd [name]="'chevron-down'" [size]="'xs'" />
  </button>

  <sb-menu #statusMenu>
    <ng-template sbMenuDeferredContent>
      <sb-menu-section [ariaLabel]="'Status' | translate" [value]="status()">
        @for (option of options; track option.status) {
          <button [sbMenuItemRadio]="option.status" (triggered)="selectStatus(option.status)">
            {{ option.label | translate }}
          </button>
        }
      </sb-menu-section>
    </ng-template>
  </sb-menu>
}
